<template>
  <div style="padding-top: 70px; background: #fff">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <h4 class="header-title">存款</h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
        <!-- <a v-if="!$store.state.token" @click="$parent.goNav('/login')" class="header-action" id="login_btn" style="font-size: 12px">登录</a> -->
      </div>
    </div>
    <!-- 银行卡 -->
    <div class="payBox" style="margin: 0 auto" v-if="pay_way == 'bank' && !(userbank.length == 0 && userUSD.length == 0)">
      <div class="paytop">银行卡信息</div>
      <div class="bans" style="" v-for="(item, index) in cardLis" :key="index">
        <p>
          <span class="frists"> 收款账号 </span><span class="sdsw">{{ item.bank_no }}</span
          ><span class="copy" @click="doCopy(item.bank_no)"> 复制 </span>
        </p>
        <p>
          <span class="frists"> 银行户名 </span><span class="sdsw">{{ item.bank_owner }}</span
          ><span class="copy" @click="doCopy(item.bank_owner)"> 复制 </span>
        </p>
        <p>
          <span class="frists"> 开户行 </span><span class="sdsw">{{ item.bank_data.bank_name }}</span
          ><span class="copy" @click="doCopy(item.bank_data.bank_name)"> 复制 </span>
        </p>
        <p>
          <span class="frists"> 银行地址 </span><span class="sdsw">{{ item.bank_address }}</span
          ><span class="copy" @click="doCopy(item.bank_address)"> 复制 </span>
        </p>
      </div>
    </div>
    <div v-if="pay_way == 'bank'" style="height: 20px"></div>
    <!-- 金额输入 -->
    <div class="meyBox">
      <div v-if="pay_way == 'bank'">
        <div @click="changShow">
          <div class="tops"><img src="/static/image/icon_rmb2.png" alt="" />存款银行</div>
          <input type="text" class="inpts" v-model="bankBox.bank" placeholder="请选择存款银行" disabled />
        </div>
        <div class="tops"><img src="/static/image/icon_rmb2.png" alt="" />存款人姓名</div>
        <input type="text" class="inpts" v-model="bankBox.bank_owner" placeholder="请输入存款人姓名" />
        <div class="tops"><img src="/static/image/icon_rmb2.png" alt="" />银行卡号</div>
        <input type="text" class="inpts" v-model="bankBox.bank_no" placeholder="请输入银行卡号" />
        <div class="tops"><img src="/static/image/icon_rmb2.png" alt="" />开户行地址</div>
        <input type="text" class="inpts" v-model="bankBox.bank_address" placeholder="请输入开户行地址" />
      </div>
      <div v-if="pay_way == 'usdt'">
        <div class="tops"><img src="/static/image/icon_rmb2.png" alt="" />钱包协议</div>

        <div class="ulsdf" style="justify-content: start">
          <div :class="meyXi == 'TRC20' ? 'meyvas lis' : 'lis'" @click="changXiyi('TRC20')">TRC20</div>
          <div style="margin-left: 15px" :class="meyXi == 'ERC20' ? 'meyvas lis' : 'lis'" @click="changXiyi('ERC20')">ERC20</div>
        </div>
      </div>
      <div class="tops"><img src="/static/image/icon_rmb2.png" alt="" />输入输入金额及快速选择</div>
      <input type="text" class="inpts" v-model="amount" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" />
      <div class="ulsdf">
        <div :class="item == amount ? 'meyvas lis' : 'lis'" v-for="(item, index) in meyList" @click="amount = item" :key="index">{{ item }}</div>
      </div>
      <div v-if="pay_way == 'usdt'">
        <div class="tops"><img src="/static/image/icon_rmb2.png" alt="" />≈ {{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }}USDT &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.usdtrate }}</div>
      </div>
    </div>
    <!-- 支付通道 -->
    <div class="payBox">
      <div class="paytop">支付通道</div>
      <div class="payList" @click="changPayway('bank')" v-if="payWayList.card == 1">
        <img src="/static/image/icoOnlineTransfer2@3x.png" />
        <div class="name">银行卡支付</div>
        <div class="ches">
          <img v-if="pay_way == 'bank'" src="/static/image/icon_checked.png" alt="" />
        </div>
      </div>
      <div class="payList" @click="changPayway('usdt')" v-if="payWayList.usdt == 1">
        <img src="/static/image/uacPoGJzdWaAXIAYAAAZE6ysp-Y242.png" />
        <div class="name">USDT钱包支付</div>
        <div class="ches">
          <img v-if="pay_way == 'usdt'" src="/static/image/icon_checked.png" alt="" />
        </div>
      </div>
      <div class="payList" @click="changPayway('wechat')" v-if="payWayList.wechat == 1">
        <img src="/static/image/QuickWechat.png" />
        <div class="name">微信支付</div>
        <div class="ches">
          <img v-if="pay_way == 'wechat'" src="/static/image/icon_checked.png" alt="" />
        </div>
      </div>
      <div class="payList" @click="changPayway('alipay')" v-if="payWayList.alipay == 1">
        <img src="/static/image/pay_alipay.png" />
        <div class="name">支付宝支付</div>
        <div class="ches">
          <img v-if="pay_way == 'alipay'" src="/static/image/icon_checked.png" alt="" />
        </div>
      </div>
    </div>
    <div
      @click="payTest"
      style="width: 100%; height: 40px; line-height: 40px; color: #fff; background-image: linear-gradient(63deg, #ff944b 0%, #fcc166 100%, #fcc166 100%); font-size: 16px; font-weight: bold; text-align: center; border-radius: 5px; border: none; outline: 0; display: block; margin-top: 20px"
    >
      提交
    </div>
    <div style="font-size: 0.4rem; border: 1px solid #ffae54; box-sizing: border-box; padding: 20px; width: 90%; margin: 0 auto; margin-top: 20px; border-radius: 10px">
      温馨提示：
      <br />
      ① 每一次存款都需要使用存款通道获取最新的收款信息，收款信息会不定期进行更换，请勿使用存款记录里旧收款卡信息，否则无法到账。<br />
      ② 支付金额须与提交金额一致，请勿修改金额，否则将无法上分或影响上分速度。<br />
      ③ 尊贵的会员，由于线上会员参与踊跃，且恰逢热门赛事繁多之际，导致网站存款业务暴增，为了保证您的存款及时到账，建议您避开【23:55-00:05】夜间存款高峰时间段或选择使用USDT存款。<br />
    </div>
    <div style="height: 30px"></div>
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="银行类型" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
    <div class="popup popup-notice" style="display: block" v-if="userbank.length == 0 && userUSD.length == 0">
      <div class="popup-wrap">
        <h2><i></i>温馨提示<a href="javascript:void(0);" class="popup-close" @click="$router.back()">关闭</a></h2>
        <div class="popup-content">
          <p id="homeNoticeList" >您还为绑定任何钱包卡片，请前往绑定！</p>
        </div>
        <div class="popup-footer">
          <a id="noticeAction" class="btn-grey" @click="$parent.goNav('/addBankCard')"> 前往绑定银行卡</a>
          <a @click="$parent.goNav('/wallet?type=2&show=1')">前往绑定USDT</a>
        </div>
      </div>
      <div class="popup-mask" onclick="javascript:void(0);"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: 'rengong',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      bankBox: {},
      meyXi: 'ERC20',
      payWayList: {},
      show: false,
      meyList: [100, 499, 999, 1299, 2199],
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
    };
  },
  created() {
    let that = this;
    that.getPayWay();
    that.getBanklist();
    that.getcard();
  },
  methods: {
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') {
        type = 'bank';
      }
      if (that.pay_way == 'wechat') {
        type = 'wechat';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    changXiyi(val) {
      if (this.meyXi == val) {
        return;
      }
      this.meyXi = val;
      this.getPayRange();
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            let obj = that.payWayList;
            for (let i in obj) {
              if (obj[i] == 1) {
                that.pay_way = i == 'card' ? 'bank' : i;
                that.hideLoading();
                that.getPayRange();

                console.log(123);
                return;
              }
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    payTest() {
      let that = this;
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.showTost(0, '请输入存款人姓名');
          return;
        }
        if (!info.bank) {
          that.showTost(0, '请输入银行类型');
          return;
        }

        if (!info.bank_no) {
          that.showTost(0, '请输入银行卡号');
          return;
        }
        if (!info.bank_address) {
          that.showTost(0, '请输入银行开户行地址');
          return;
        }
      } else {
        //暂时
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
        };
      }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'bank') {
              that.showTost(1, '提交成功，等待后台审核');
              that.bankBox = {};
              that.amount = null;
              that.hideLoading();
              that.$router.push({ path: '/transRecord' });
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.$router.push({ path: `/payInfo?deposit_no=${res.message}` });
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.hideLoading();
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      that.getPayRange();
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, '复制成功！');
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      let that = this;
      vm.getuseCardlist();
    });
  },
};
</script>

<style lang="scss" scoped>
.meyBox {
  font-size: 0.4rem;
  width: calc(100% - 20px);
  margin: 0 auto;
  border-radius: 15px;
  box-shadow: 0 0 10px rgb(221 221 221 / 50%), 0 0 10px rgb(221 221 221 / 50%), 0 0 10px rgb(221 221 221 / 50%), 0 0 10px rgb(221 221 221 / 50%);
  background: url(/static/image/deposit_field_bg.png) no-repeat right;
}
.inpts {
  border: none;
  display: block;
  margin: 0 auto;
  height: 1rem;
  line-height: 1rem;
  width: calc(100% - 108px);
  background: none;
}
.ulsdf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ccc;
  box-sizing: border-box;
  padding: 10px 20px;
  .lis {
    display: block;
    width: 16%;
    height: 0.6rem;
    background-color: #fff;
    text-align: center;
    line-height: 0.6rem !important;
    border-radius: 6px;
    color: #727272;
    font-size: 12px;
    border: 1px solid #bebebe;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .meyvas {
    background: linear-gradient(to bottom, #fdce69, #fb914c);
    color: #fff;
    border: 1px solid #fdcc68;
  }
}
.tops {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 20px;
  img {
    width: 20px;
    margin-right: 12px;
  }
}

.payBox {
  font-size: 0.2rem;
  width: calc(100% - 20px);
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 15px;
  box-shadow: 0 0 10px rgb(221 221 221 / 50%), 0 0 10px rgb(221 221 221 / 50%), 0 0 10px rgb(221 221 221 / 50%), 0 0 10px rgb(221 221 221 / 50%);
  overflow: hidden;
  .paytop {
    width: 100% !important;
    height: 1rem;
    line-height: 1rem !important;
    text-align: center;
    background-color: #f6f8fa;
    padding: 0;
    border-bottom: 0;
  }
  .payList {
    display: flex;
    align-items: center;
    box-shadow: 0 0 0.5vw 0.5vw rgb(221 221 221 / 50%);
    border-radius: 5px;
    border-bottom: none;
    margin-top: 12px;
    justify-content: space-between;
    height: 1.5rem;
  }
  .name {
    flex: 1;
  }
  img {
    width: 1rem;
    margin: 0 15px;
  }
  .ches {
    border: 1px solid #ccc;
    border-radius: 50%;
    margin: 0 15px;
    width: 0.8rem;
    height: 0.8rem;

    img {
      width: 0.8rem;
      margin: 0;
    }
  }
}
.bans {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .frists {
      width: 60px;
    }
    .sdsw {
      flex: 1;
    }
    .copy {
      color: #069b71;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue